/**
 * APP_ROUTES
 * 
 * Centralized route management for the application.
 * WHY: Single source of truth for all route paths, matching kyc-client-admin pattern.
 */
export const ROUTES = {
  HOME: "/",

  DASHBOARD: "/",
  TRANSCRIPT_EXTRACTION: "/transcript-extraction",
  DOC_EXTRACTION: "/doc-extraction",
  CONSENT_EXTRACTION: "/consent-extraction",
  BATCH_PROCESSING: "/batch",
  BATCH_HISTORY: "/batch-history",
  BATCH_DETAIL: "/batch-history/:batchId",
  RECORD_DETAIL: "/batch-history/:batchId/record/:requestId",
  MULTI_PAGE_DETAIL: "/batch-history/:batchId/record/:requestId/students",
  EXTRACTION_HISTORY: "/history",
  PRE_PROCESSING: "/pre-processing",
  PRE_PROCESSING_HISTORY: "/pre-processing-history",
  PRE_PROCESSING_DETAIL: "/pre-processing-history/:id",
  NON_PROCESSED_FILE_DETAIL: "/pre-processing-history/:id/non-processed/:fileId",
  PROCESSED_FILE_DETAIL: "/pre-processing-history/:id/processed/:fileId",
  SETTINGS: "/settings",

  // Auth routes
  CALLBACK: "/callback",
  UNAUTHORIZED: "/unauthorized",

  // Help Center
  HELP_CENTER: "/help-center",

  // External URLs
  TERMS_CONDITIONS: "https://verif-y.com/terms-and-conditions",
  PRIVACY_POLICY: "https://verif-y.com/privacy-policy",
  FAQ: "https://www.verif-y.com/faq",
  APP_VERSION: "1.0.0"
} as const;

export default ROUTES;
